export default __webpack_public_path__ + "static/media/03.4a0da325.jpg";